<template>
    <button class="bg-[#ffa700] text-base rounded-sm py-4 w-full text-white font-semibold"
    @click="openRateModal">{{ $t('page.rate') }}</button>
</template>

<script>
export default {
  methods: {
    openRateModal(){
        if (this.$store.authStatus){
            this.$store.modals.rateModal = true
        }else{
            this.$store.loginModal = true
        }
    }
  }
};
</script>